import classNames from "classnames";
import { MouseEventHandler, ReactNode } from "react";
import UserAlertIcon from "rivals/components/app/Layout/Header/AccountLinks/UserAlerts/UserAlertIcon";
import { ALERT_TYPES } from "rivals/components/app/Layout/Header/AccountLinks/types";
import styles from "./UserAlertListItem.module.scss";
import strings from "./strings";
import type { Props } from "./types";

function getAlertTitle(type: string): string {
  if (
    [
      ALERT_TYPES.EntersTransferPortal,
      ALERT_TYPES.IntendsToEnterTransferPortal,
      ALERT_TYPES.Transfer,
      ALERT_TYPES.WithdrawsFromTransferPortal
    ].includes(type as ALERT_TYPES)
  ) {
    return strings.transferPortalUpdate;
  }
  return type;
}

const UserAlertListItem = ({
  index,
  isRead,
  userAlert,
  onClick: onClickCallback,
  userAlert: { alertSource, alertText, alertType, eventDate, siteName }
}: Props): ReactNode => {
  const onClick: MouseEventHandler<HTMLButtonElement> = (e): void => {
    // Stop propagation to prevent automatic closing of the parent drop down when clicking on an alert. Clicking an
    // alert opens a new tab for the alert's URL, and the user will want to maintain their place in the drop down
    // when navigating back to the previous tab.
    e.stopPropagation();

    onClickCallback(userAlert, index);
  };

  return (
    <button
      className={classNames(styles.userAlertListItem, {
        [styles.firstUserAlertListItem]: index === 0
      })}
      onClick={onClick}
    >
      <div className={styles.userAlertIconWrapper}>
        <UserAlertIcon userAlert={userAlert} />
      </div>
      <div>
        <div className={styles.userAlertListItemTopRow}>
          {alertSource === "forums" ? "Forums" : getAlertTitle(alertType)}
        </div>
        <div className={styles.userAlertListItemMiddleRow}>
          <div
            className={classNames({
              [styles.bold]: !isRead(userAlert, index)
            })}
          >
            {alertText}
          </div>
        </div>
        <div className={styles.userAlertListItemBottomRow}>
          <div>{eventDate}</div>
          <div className={styles.userAlertListItemBottomRowSeparator}>
            &middot;
          </div>
          <div>{siteName}</div>
        </div>
      </div>
    </button>
  );
};

export default UserAlertListItem;
